import React from 'react';

import {
    DetailsContent,
    DetailsItem,
    HeaderTextWrapper,
    HeaderWrapper,
    Heading,
    MainContent,
    SubHeading,
} from './styles';

export const ContentSkeletonDetails = () => {
    return (
        <DetailsContent>
            {Array(6)
                .fill(null)
                .map((_, i) => (
                    <DetailsItem key={`detailItemSkeleton${i}`} $isLoading />
                ))}
        </DetailsContent>
    );
};

export const ContentSkeleton = () => {
    return (
        <>
            <MainContent>
                <HeaderWrapper>
                    <HeaderTextWrapper>
                        <Heading $isLoading />
                        <SubHeading $isLoading />
                    </HeaderTextWrapper>
                </HeaderWrapper>
                <ContentSkeletonDetails />
            </MainContent>
        </>
    );
};
